import angular from 'angular';

(function () {
    'use strict';

    // Component DEF
    var kissReferentialSection = {
        controller: 'ReferentialSectionCtrl as vm',
        templateUrl: require('./referential-section.html'),
        bindings: {
            section: '<',
        }
    };
    // Add to the App
    angular.module('app.principal').component('kissReferentialSection', kissReferentialSection);
})();
